module.exports = __webpack_public_path__ + "static/absolutecard-9bb37ff765f583cb0dd303ae7018e5e7.png";